import { mapActions, mapState } from 'vuex'
import * as XLSX from 'xlsx/xlsx.mjs'
import store from '@/store'
import axios from 'axios'
import router from '@/router/'
import FiltroReportes from '@/components/Layout/Menu/Filtros/Filtro_Reportes/FiltroReportes.vue'
// import BarChart from '@/components/Layout/Menu/Graficos/BarChart/BarChart.vue'
// import store from '@/store'

export default {
  name: 'ReportesCargas',
  components: {
    FiltroReportes
  },
  props: {
  },
  data: function () {
    return {
      items: [],
      fields: [
        {
          key: 'cliente',
          label: 'Cliente',
          sortable: false
        },
        {
          key: 'transporte',
          label: 'Transporte',
          sortable: false
        },
        {
          key: 'fecha',
          label: 'Fecha',
          sortable: true
        },
        {
          key: 'status',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'ucase',
          label: 'Ucase',
          sortable: true
        },
        {
          key: 'destino',
          label: 'Destino',
          sortable: true
        },
        {
          key: 'kilometros',
          label: 'Kilometros',
          sortable: true
        },
        {
          key: 'cam_basis',
          label: 'Nro Cam',
          sortable: false
        },
        {
          key: 'nombre_conductor',
          label: 'Conductor',
          sortable: false
        },
        {
          key: 'ayudante1',
          label: 'Ayudante 1',
          sortable: false
        },
        {
          key: 'ayudante2',
          label: 'Ayudante 2',
          sortable: false
        },
        {
          key: 'ayudante3',
          label: 'Ayudante 3',
          sortable: false
        },
        {
          key: 'tipo_documento',
          label: 'Tipo Documento',
          sortable: false
        },
        {
          key: 'nro_documento',
          label: 'Nro Documento',
          sortable: false
        },
        {
          key: 'aaCatRet',
          label: 'AaCatRet',
          sortable: false
        },
        {
          key: 'traeEnvases',
          label: 'Trae Envases',
          sortable: false
        },
        {
          key: 'traePallet',
          label: 'Trae Pallet',
          sortable: false
        },
        {
          key: 'traeRebal',
          label: 'Trae Rebal',
          sortable: false
        },
        {
          key: 'traeProducto',
          label: 'Trae Producto',
          sortable: false
        },
        {
          key: 'responsable_cambio',
          label: 'Responsable Cambio',
          sortable: false
        },
        {
          key: 'fecha_cambio',
          label: 'Fecha Cambio',
          sortable: false
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
      sortBy: 'fecha',
      sortDesc: true,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      activeColor: 'arial',
      fontSize: 13,
      dataFiltroReporte: {},
      filtroEstadoEnable: true,
      filtroCamionEnable: true,
      filtroConductorEnable: true,
      filtroClienteEnable: true,
      filtroRevisionEnable: true
    }
  },
  watch: {
    dataFiltroReporte: function (val) {
      console.log('observador dataFiltroReporte')
      console.log(this.dataFiltroReporte)
      const periodos = this.PeriodoFechaActual()
      console.log(periodos)
      // if (this.dataFiltroReporte.cliente !== undefined) {
      //   console.log('tiene filtro de cliente')
      // }
      // if (this.dataFiltroReporte.conductor !== undefined) {
      //   console.log('tiene filtro de conductor')
      // }
      // if (this.dataFiltroReporte.camion !== undefined) {
      //   console.log('tiene filtro de camion')
      // }
      this.getCargas(this.dataFiltroReporte).then((res) => {
        console.log('cargo reporte cargas')
        this.items = []
        this.items = res
        if (this.dataFiltroReporte.cliente !== undefined) {
          console.log('tiene filtro de cliente')
          this.items = this.items.filter(cliente => cliente.cliente === this.dataFiltroReporte.cliente)
        }
        if (this.dataFiltroReporte.conductor !== undefined) {
          this.items = this.items.filter(conductor => conductor.nombre_conductor === this.dataFiltroReporte.conductor)
          console.log('tiene filtro de conductor')
        }
        if (this.dataFiltroReporte.camion !== undefined) {
          this.items = this.items.filter(camion => camion.cam_basis === this.dataFiltroReporte.camion)
          console.log('tiene filtro de camion')
        }
        if (this.dataFiltroReporte.estado !== undefined) {
          this.items = this.items.filter(camion => camion.status === this.dataFiltroReporte.estado)
          console.log('tiene filtro de camion')
        }
        if (this.dataFiltroReporte.cliente === undefined && this.dataFiltroReporte.conductor === undefined && this.dataFiltroReporte.camion === undefined && this.dataFiltroReporte.estado === undefined) {
          console.log('no tiene filtro')
          this.items = res
        }
        // let itemFiltroCliente = []
        // let itemFiltroConductor = []
        // let itemFiltroCamion = []
        // for (const filtro in res) {
        //   // let flagExisteFiltro = false
        //   if (this.dataFiltroReporte.cliente !== undefined) {
        //     console.log('tiene filtro de cliente')
        //     if (this.dataFiltroReporte.cliente === res[filtro].cliente) {
        //       this.items.push(res[filtro])
        //       continue
        //     }
        //   }
        //   if (this.dataFiltroReporte.conductor !== undefined) {
        //     console.log('tiene filtro de conductor')
        //     if (this.dataFiltroReporte.conductor === res[filtro].nombre_conductor) {
        //       this.itemFiltroCliente.push(res[filtro])
        //       continue
        //     }
        //   }
        //   if (this.dataFiltroReporte.camion !== undefined) {
        //     console.log('tiene filtro de camion')
        //     if (this.dataFiltroReporte.camion === res[filtro].cam_basis) {
        //       itemFiltroCliente.push(res[filtro])
        //       continue
        //     }
        //   }
        // }
        // this.items = res
        this.totalRows = this.items.length
      })
      this.totalRows = this.items.length
    }
  },
  mounted () {
    const periodos = this.PeriodoFechaActual()
    this.getCargas(periodos).then((res) => {
      this.items = res
      console.log('cargo reporte cargas')
      this.totalRows = this.items.length
    })
    this.totalRows = this.items.length
  },
  methods: {
    ...mapActions('AdministradorFlota', [
      'getTransportes', 'getConductores', 'getAyudantes', 'getCamiones'
    ]),
    info (item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal () {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    exportarExcel () {
      console.log('exportar excel')
      // XLSX.writeFile(wb, 'cumplimiento.xlsx')
      const itemsAux = []
      let items = {}
      for (const item in this.items) {
        items = {}
        for (const [key, value] of Object.entries(this.items[item])) {
          // console.log('key: ' + key)
          // console.log('value: ' + value )
          if (!key.includes('_cellVariants')) {
            // console.log('key: ' + key)
            // console.log('value: ' + value)
            items[key] = value
          }
        }
        itemsAux.push(items)
      }
      const ws = XLSX.utils.json_to_sheet(itemsAux)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'transportes')
      XLSX.writeFile(wb, 'transportes.xlsx')
      // console.log(itemsAux)
      // console.log(semanas)
      // console.log(this.items)
    },
    async getCargas (periodo) {
      try {
        const response = await axios({
          method: 'post',
          // url: `https://n1ffdxatvc.execute-api.us-west-1.amazonaws.com/prod/cliente/${store.state.cliente}/equipo?marca=${store.state.marca}`,
          // url: `http://${store.state.host}/api/vps/getTransportes`,
          url: `${store.state.host}/api/vps/vueltas/getReportePorCarga`,
          data: {
            // fechaDesde: '2022-08-18 00:00:00',
            // fechaHasta: '2022-08-19 23:00:00'
            fechaDesde: periodo.fechaDesde,
            fechaHasta: periodo.fechaHasta
          },
          headers: {
            Authorization: 'Bearer ' + store.state.token
          }
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log(response.data)
          return response.data
        } else {
          console.log('por else getCargas')
        }
        return false
      } catch (err) {
        console.error(err)
        console.log('por catch getCargas')
        router.push({ path: '/' })
        return false
      }
    },
    PeriodoFechaActual () {
      const date = new Date()
      // const fechaActual = `${
      //   date.getFullYear().toString().padStart(4, '0')}-${
      //     (date.getMonth() + 1).toString().padStart(2, '0')}-${
      //       date.getDate().toString().padStart(2, '0')}T${
      //         date.getHours().toString().padStart(2, '0')}:${
      //           date.getMinutes().toString().padStart(2, '0')}:${
      //             date.getSeconds().toString().padStart(2, '0')}.000+00:00`
      const fechaActualPrimeraHora = `${
        date.getFullYear().toString().padStart(4, '0')}-${
          (date.getMonth() + 1).toString().padStart(2, '0')}-${
            date.getDate().toString().padStart(2, '0')} ${
              '00'}:${
                '00'}:${
                  '00'}`
      const fechaActualUltimaHora = `${
        date.getFullYear().toString().padStart(4, '0')}-${
          (date.getMonth() + 1).toString().padStart(2, '0')}-${
            date.getDate().toString().padStart(2, '0')} ${
              '23'}:${
                '59'}:${
                  '59'}`
      console.log(fechaActualPrimeraHora)
      console.log(fechaActualUltimaHora)
      const periodo = {}
      periodo.fechaDesde = fechaActualPrimeraHora
      periodo.fechaHasta = fechaActualUltimaHora
      return periodo
    },
    test () {
      this.getCargas().then((res) => {
        this.items = res
        console.log('cargo')
      })
    }
  },
  computed: {
    ...mapState('AdministradorFlota', ['transportes']),
    ...mapState('AdministradorFlota', ['transportes2']),
    ...mapState('AdministradorFlota', ['camiones']),
    ...mapState('AdministradorFlota', ['conductores']),
    ...mapState('AdministradorFlota', ['transportesNoAsignados']),
    ...mapState('AdministradorFlota', ['listaTransportesStore']),
    ...mapState('KPIStatusTransporte', ['kpi']),
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  }
}
